// extracted by mini-css-extract-plugin
module.exports = {"editor":"editor--3K9XX"};